import { useDispatch, useSelector } from "react-redux"
import { TableTks } from "../tools/TableTks"
import { Adddata, db } from "../../data"
import { collection, doc, getDocs } from "firebase/firestore"
import { addCondiciones } from "../../store/condicionesDePago/CondicionesDePagoSlices"
import { useEffect, useMemo, useState } from "react"
import searchIco from '../../assets/images/searchIco.png'
import { ToastError, ToastSucces } from "../tools"

export const CondDePago = () => {
    const defaultCommerceIds = ['goldmund', 'escorial']
    const pymntGroups = useSelector(state => state.condicionesDePago)
    const [updating, setUpdating] = useState(false)
    const [loading, setLoading] = useState(true)
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedCommerceId, setSelectedCommerceId] = useState('goldmund')
    const [paymentDocs, setPaymentDocs] = useState({})
    const [docIdsByCommerce, setDocIdsByCommerce] = useState({})
    const [commerceIds, setCommerceIds] = useState(defaultCommerceIds)
    const [creating, setCreating] = useState(false)
    const [newCondition, setNewCondition] = useState({
        GroupNum: '',
        PymntGroup: '',
        Habilitado: true,
    })

    const dispatch = useDispatch()

    const normalizeText = (value) => {
        if (!value) return ''
        return value
            .toString()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
    }

    const filteredConditions = useMemo(() => {
        const source = Array.isArray(pymntGroups) ? pymntGroups : []
        const search = normalizeText(searchTerm.trim())

        if (!search) return source

        return source.filter((item) =>
            [item.GroupNum, item.PymntGroup, item.Habilitado]
                .some((field) => normalizeText(field).includes(search))
        )
    }, [pymntGroups, searchTerm])

    const loadPaymentConditions = async () => {
        setLoading(true)
        try {
            const snapshot = await getDocs(collection(db, 'Condiciones_de_pago'))
            const nextDocs = {}
            const nextDocIds = {}
            const nextCommerceIds = new Set(defaultCommerceIds)

            snapshot.forEach((snapshotDoc) => {
                const data = snapshotDoc.data()
                const commerceId = data.CommerceId || 'goldmund'
                nextDocs[commerceId] = Array.isArray(data.Condiciones) ? data.Condiciones : []
                nextDocIds[commerceId] = snapshotDoc.id
                nextCommerceIds.add(commerceId)
            })

            const normalizedCommerceIds = [...nextCommerceIds]
            const activeCommerceId = normalizedCommerceIds.includes(selectedCommerceId)
                ? selectedCommerceId
                : normalizedCommerceIds[0]

            setPaymentDocs(nextDocs)
            setDocIdsByCommerce(nextDocIds)
            setCommerceIds(normalizedCommerceIds)
            setSelectedCommerceId(activeCommerceId)
            dispatch(addCondiciones(nextDocs[activeCommerceId] || []))
        } catch (error) {
            ToastError(`No se pudieron cargar las condiciones de pago: ${error}`)
            setPaymentDocs({})
            setDocIdsByCommerce({})
            setCommerceIds(defaultCommerceIds)
            setSelectedCommerceId('goldmund')
            dispatch(addCondiciones([]))
        } finally {
            setLoading(false)
        }
    }

    const handleChangePymntGroup = async (data, value) => {
        setUpdating(true)

        const updatedArray = pymntGroups.map((element) => {
            if (element.GroupNum === data.GroupNum) {
                return { ...element, Habilitado: value }
            }
            return element
        })

        try {
            const docId = docIdsByCommerce[selectedCommerceId]
            const docRef = docId
                ? doc(db, 'Condiciones_de_pago', docId)
                : doc(collection(db, 'Condiciones_de_pago'))

            await Adddata(docRef, {
                CommerceId: selectedCommerceId,
                Condiciones: updatedArray
            })

            const finalDocId = docId || docRef.id

            setDocIdsByCommerce((prev) => ({
                ...prev,
                [selectedCommerceId]: finalDocId
            }))
            setPaymentDocs((prev) => ({
                ...prev,
                [selectedCommerceId]: updatedArray
            }))
            dispatch(addCondiciones(updatedArray))
        } catch (error) {
            ToastError(`No se pudo actualizar la condicion de pago: ${error}`)
        } finally {
            setUpdating(false)
        }
    }

    const handleCommerceChange = ({ target: { value } }) => {
        setSelectedCommerceId(value)
        dispatch(addCondiciones(paymentDocs[value] || []))
    }

    const handleNewConditionChange = ({ target: { name, value, type, checked } }) => {
        setNewCondition((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }))
    }

    const handleCreateCondition = async (e) => {
        e.preventDefault()

        const groupNum = parseInt(newCondition.GroupNum, 10)
        const pymntGroupName = newCondition.PymntGroup.trim()

        if (!groupNum || !pymntGroupName) {
            ToastError('Completa codigo y nombre de la condicion de pago')
            return
        }

        if (pymntGroups.some((condition) => Number(condition.GroupNum) === groupNum)) {
            ToastError(`Ya existe una condicion con codigo ${groupNum} en ${selectedCommerceId}`)
            return
        }

        setCreating(true)

        const updatedArray = [...pymntGroups, {
            GroupNum: groupNum,
            PymntGroup: pymntGroupName,
            Habilitado: Boolean(newCondition.Habilitado)
        }]

        try {
            const docId = docIdsByCommerce[selectedCommerceId]
            const docRef = docId
                ? doc(db, 'Condiciones_de_pago', docId)
                : doc(collection(db, 'Condiciones_de_pago'))

            await Adddata(docRef, {
                CommerceId: selectedCommerceId,
                Condiciones: updatedArray
            })

            const finalDocId = docId || docRef.id

            setDocIdsByCommerce((prev) => ({
                ...prev,
                [selectedCommerceId]: finalDocId
            }))
            setPaymentDocs((prev) => ({
                ...prev,
                [selectedCommerceId]: updatedArray
            }))
            dispatch(addCondiciones(updatedArray))
            setNewCondition({
                GroupNum: '',
                PymntGroup: '',
                Habilitado: true,
            })
            ToastSucces('Condicion de pago agregada')
        } catch (error) {
            ToastError(`No se pudo crear la condicion de pago: ${error}`)
        } finally {
            setCreating(false)
        }
    }

    useEffect(() => {
        loadPaymentConditions()
    }, [])

    return (
        <>
            <h4 className='separar my-4'>
                <b className='text-uppercase'>Habilitar / Deshabilitar Con. de Pago</b>
            </h4>

            <div className="adminPanelToolbar">
                <div className="adminSearch">
                    <img src={searchIco} alt="Buscar" className="adminSearchIcon" />
                    <input
                        type="text"
                        className="form-control inputs adminSearchInput"
                        placeholder="Buscar condicion de pago"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <select
                    className="form-control inputs adminFilterSelect"
                    value={selectedCommerceId}
                    onChange={handleCommerceChange}
                    disabled={loading || updating}
                >
                    {commerceIds.map((commerceId) => (
                        <option key={commerceId} value={commerceId}>
                            {commerceId}
                        </option>
                    ))}
                </select>

                <div className="adminListMeta">
                    {filteredConditions.length} condiciones en {selectedCommerceId}
                </div>
            </div>

            <form className="gerenciasCreateForm mb-3" onSubmit={handleCreateCondition}>
                <div className="gerenciasCreateFields">
                    <input
                        className="form-control inputs"
                        name="GroupNum"
                        placeholder="Codigo"
                        value={newCondition.GroupNum}
                        onChange={handleNewConditionChange}
                        disabled={loading || updating || creating}
                    />
                    <input
                        className="form-control inputs"
                        name="PymntGroup"
                        placeholder="Nombre de condicion"
                        value={newCondition.PymntGroup}
                        onChange={handleNewConditionChange}
                        disabled={loading || updating || creating}
                    />
                    <label className="userStatusToggle">
                        <span className={`userStatusLabel ${newCondition.Habilitado ? 'userStatusLabel--active' : ''}`}>
                            Habilitada
                        </span>
                        <span className="userStatusSwitch">
                            <input
                                type="checkbox"
                                name="Habilitado"
                                checked={newCondition.Habilitado}
                                onChange={handleNewConditionChange}
                                disabled={loading || updating || creating}
                            />
                            <span className="userStatusSlider"></span>
                        </span>
                    </label>
                </div>

                <div className="gerenciasActions">
                    <button
                        type="submit"
                        className="btn btn-outline btnBlue text-uppercase fw-bold"
                        disabled={loading || updating || creating}
                    >
                        {creating ? 'Guardando...' : 'Agregar condicion'}
                    </button>
                </div>
            </form>

            {
                loading
                    ? <div className="adminEmptyState">Cargando condiciones de pago...</div>
                    : <>
                        <TableTks
                            section='CONFIGURACION'
                            data={filteredConditions}
                            handleChange={handleChangePymntGroup}
                            updating={updating}
                        />
                        {!docIdsByCommerce[selectedCommerceId] && (
                            <div className="gerenciasFixedValues mt-2">
                                No existe documento para este comercio todavia. Se creara automaticamente al editar una condicion.
                            </div>
                        )}
                    </>
            }
        </>
    )
}
